"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Icons;
(function (Icons) {
    Icons["Facebook"] = "la la-facebook-official";
    Icons["Twitter"] = "la la-twitter";
    Icons["LinkedIn"] = "la la-linkedin";
    Icons["Instagram"] = "la la-instagram";
    Icons["YouTube"] = "la la-youtube-play";
    Icons["Check"] = "la la-check";
    Icons["CheckCircle"] = "la la-check-circle";
    Icons["Circle"] = "la la-circle-o";
    Icons["Search"] = "la la-search";
    Icons["Question"] = "la la-question-circle";
    Icons["Cross"] = "la la-close";
    Icons["Upload"] = "la la-cloud-upload";
    Icons["Lightbulb"] = "la la-lightbulb-o";
    Icons["Pin"] = "la la-map-marker";
    Icons["Globe"] = "la la-globe";
    Icons["Edit"] = "la la-edit";
    Icons["RSS"] = "la la-rss";
    Icons["Suitcase"] = "la la-suitcase";
    Icons["Exclamation"] = "la la-exclamation-triangle";
    Icons["Filter"] = "la la-filter";
    Icons["User"] = "la la-user";
    Icons["CreateOwn"] = "la la-star";
    Icons["BusinessSuperstar"] = "la la-money";
    Icons["CreativeGenius"] = "la la-paint-brush";
    Icons["AdminStar"] = "la la-book";
    Icons["TechWiz"] = "la la-terminal";
    Icons["MarketingGuru"] = "la la-commenting-o";
    Icons["RDRockstar"] = "la la-pie-chart";
    Icons["ChevronDown"] = "la la-angle-down";
    Icons["ChevronUp"] = "la la-angle-up";
    Icons["Image"] = "la la-image";
    Icons["Attachment"] = "la la-paperclip";
    Icons["Mail"] = "la la-envelope";
    Icons["Phone"] = "la la-mobile";
    Icons["Link"] = "la la-link";
    Icons["Sliders"] = "la la-sliders";
    Icons["Shield"] = "la la-shield";
    Icons["Person"] = "la la-street-view";
    Icons["Social"] = "la la-share-alt";
})(Icons || (Icons = {}));
exports.default = Icons;
//# sourceMappingURL=icons.js.map